import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=2d70a2fc&"
import script from "./DownloadLink.vue?vue&type=script&lang=js&"
export * from "./DownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports